import overrides from 'theme/overrides';
import { createTheme } from '@mui/material';
import { JBTheme } from '@bjb-gcrm/gcrm-frontend-components';

const theme = createTheme({
  palette: JBTheme.palette,
  typography: JBTheme.typography,
  components: {
    ...overrides,
    MuiButton: JBTheme.components.MuiButton,
    MuiTooltip: JBTheme.components.MuiTooltip,
  },
  zIndex: {
    appBar: 1200,
    drawer: 1100,
  },
});

export default theme;
